<sh-loggregation-grid
  [queryModel]="queryModel"
  (textInfoClicked)="onGridButtonClick($event)"
  [isGridOverlayVisible]="isGridOverlayVisible"
  [data]="data"
  (selectedItemChanged)="onSelectedItemChanged($event)"
></sh-loggregation-grid>
